import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {viewKitchenTeamTableReady,rowsViewTeamPerPageState,searchTextState,paginationViewTeamState} from '../redux/kitchens'
import {teamEmployeeIdForAction,attritionSourceAction} from '../../Teams/redux/teams'
import {employeesMovementDataForAction} from '../../Employees Movement/redux/employeesmovement'
import { headerDataUpdate, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/kitchenTable.css'


import { ChangeWorkStation } from './ActionButtons'

import * as Helpers from '../../../common/helpers'


function filterUnwantedData(kitchensData) {
    let array = []
    if (kitchensData && kitchensData.data) {
        array = kitchensData.data.employees
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : "NA"
            newLineData.code = lineData.code ? lineData.code : "NA"
            newLineData.name = lineData.name ? lineData.name : "NA"
            newLineData.mobile = lineData.mobile ? lineData.mobile : "NA"
            newLineData.kitchen_id = lineData.work_location_id ? lineData.work_location_id : "NA"
            newLineData.kitchen_name=kitchensData.data.name ? kitchensData.data.name : "NA"

            if(lineData.category){
                newLineData.designation_name=lineData.designation && lineData.designation.name ? lineData.designation.name+" - "+lineData.category : "NA"
            }else{
                newLineData.designation_name=lineData.designation && lineData.designation.name ? lineData.designation.name : "NA"

            }
            
            newLineData.work_station =lineData.working_kitchen && lineData.working_kitchen.work_station && lineData.working_kitchen.work_station.name ? lineData.working_kitchen.work_station.name : "NA"

            newLineData.kitchen_staff_id =lineData.working_kitchen && lineData.working_kitchen.id ? lineData.working_kitchen.id : "NA"

            newLineData.current_movements=false;
            
            if(lineData.working_kitchen && lineData.working_kitchen.current_movements && lineData.working_kitchen.current_movements.length>0){
                newLineData.current_movements=true;
            }

            
            newArray[i] = newLineData
        }
    }
    return newArray
}


class ViewKitchenTeamTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            kitchenTeamData: [],
            kitchenData: {},
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
            
    }

    componentDidMount() {

        if(this.props.kitchens && this.props.kitchens.kitchenSelectedId && this.props.kitchens.kitchenSelectedId !== null){
            this.props.dispatch(headerDataUpdate(Constants.VIEW_KITCHEN_TEAM))
            this.setState({subTitle: Constants.VIEW_KITCHEN_TEAM})
            this.props.dispatch(viewKitchenTeamTableReady(false))
            this.getKitchensTeamDataById(this.props.kitchens.kitchenSelectedId)
        }else{
            this.dialog.show({
                        title: "Error",
                        body: 'Kitchen ID not found',
                        actions: [
                            Dialog.OKAction(() => {
                                this.props.history.goBack()
                            })
                        ],
                        onHide: (dialog) => {
                            dialog.hide()
                            this.props.history.goBack()
                        }
                    })
        }
        
        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 250) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
   

    getKitchensTeamDataById=(kitchenId)=>{
        
       
            apiService.getKitchensTeamDataById(kitchenId)
                .then(responseData => {
                    this.props.dispatch(viewKitchenTeamTableReady(true))
                    if (responseData && responseData.status === "SUCCESS") {
                       let array = filterUnwantedData(responseData), pageNo = 1
                        if (this.props.kitchens && this.props.kitchens.previousViewTeamPaginationValue) {
                            pageNo = this.props.kitchens.previousViewTeamPaginationValue
                        }
                        this.setState({
                            kitchenData:responseData.data,
                            kitchenTeamData: array,
                            page: pageNo,
                        })
                    }
                })
                .catch(err => {
                    console.log("Error data: ", err)
                    this.props.dispatch(viewKitchenTeamTableReady(true))
                    this.dialog.show({
                        title: "Server respond with Error data",
                        body: 'Fetching Kitchen team data got interrupted',
                        actions: [
                            Dialog.OKAction(() => {
                                this.props.history.goBack()
                            })
                        ],
                        onHide: (dialog) => {
                            dialog.hide()
                            this.props.history.goBack()
                        }
                    })
                })
    }


    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.kitchens && this.props.kitchens.previousRowsPerPageValue) {
            value = this.props.kitchens.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsViewTeamPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
            <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-div-margins" style={{background:"white",paddingTop:"1%"}}>
                                    <div className="col-md-3 col-sm-12 col-xs-12">
                                         <div className="form-group">
                                                 <label className="col-sm-6 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Kitchen Name :</label>
                                                 <div className="col-sm-6">
                                                    {(() => {
                                                        if(this.state.kitchenData.name && this.state.kitchenData.name!=="" && this.state.kitchenData.name!==undefined){
                                                            return(
                                                                <p>{this.state.kitchenData.name}</p>
                                                            )
                                                        }else{
                                                            return(
                                                                <p>NA</p>
                                                            )
                                                        }
                                                    })()}                                         
                                                 </div>
                                              </div>
                                           </div> 
                                            <div className="col-md-3 col-sm-12 col-xs-12">
                                              <div className="form-group">
                                                 <label className="col-sm-6 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Kitchen Code :</label>
                                                 <div className="col-sm-6">
                                                    {(() => {
                                                        if(this.state.kitchenData.code && this.state.kitchenData.code!=="" && this.state.kitchenData.code!==undefined){
                                                            return(
                                                                <p>{this.state.kitchenData.code}</p>
                                                            )
                                                        }else{
                                                            return(
                                                                <p>NA</p>
                                                            )
                                                        }
                                                    })()}                                         
                                                 </div>
                                              </div>
                                           </div>  

                                           <div className="col-md-3 col-sm-12 col-xs-12">
                                              <div className="form-group">
                                                 <label className="col-sm-6 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Kitchen Manager :</label>
                                                 <div className="col-sm-6">
                                                    {(() => {
                                                        if(this.state.kitchenData.kitchen_manager && this.state.kitchenData.kitchen_manager.name && this.state.kitchenData.kitchen_manager.name!=="" && this.state.kitchenData.kitchen_manager.name!==undefined){
                                                            return(
                                                                <p>{this.state.kitchenData.kitchen_manager.name}</p>
                                                            )
                                                        }else{
                                                            return(
                                                                <p>NA</p>
                                                            )
                                                        }
                                                    })()}                                         
                                                 </div>
                                              </div>
                                           </div>  

                                           <div className="col-md-3 col-sm-12 col-xs-12">
                                              <div className="form-group">
                                                 <label className="col-sm-6 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Cluster Manager:</label>
                                                 <div className="col-sm-6">
                                                    {(() => {
                                                        if(this.state.kitchenData.cluster && this.state.kitchenData.cluster.cluster_manager && this.state.kitchenData.cluster.cluster_manager.name && this.state.kitchenData.cluster.cluster_manager.name!=="" && this.state.kitchenData.cluster.cluster_manager.name!==undefined){
                                                            return(
                                                                <p>{this.state.kitchenData.cluster.cluster_manager.name}</p>
                                                            )
                                                        }else{
                                                            return(
                                                                <p>NA</p>
                                                            )
                                                        }
                                                    })()}                                         
                                                 </div>
                                              </div>
                                           </div>   
                                           
                
                                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.kitchenTeamData.length>=(this.props.kitchens.previousViewTeamPaginationValue*this.props.kitchens.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.kitchens.previousViewTeamPaginationValue*this.props.kitchens.previousRowsPerPageValue)-this.props.kitchens.previousRowsPerPageValue+1} to {this.props.kitchens.previousViewTeamPaginationValue*this.props.kitchens.previousRowsPerPageValue} of {this.state.kitchenTeamData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.kitchens.previousViewTeamPaginationValue*this.props.kitchens.previousRowsPerPageValue)-this.props.kitchens.previousRowsPerPageValue+1} to {this.state.kitchenTeamData.length} of {this.state.kitchenTeamData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )  
    }

    getFilteredKitchensList = () => {
       
        this.props.dispatch(viewKitchenTeamTableReady(false))
        this.resetSearchAndPagination()
        this.getKitchensTeamDataById(this.props.kitchens.kitchenSelectedId)
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.getKitchensTeamDataById(this.props.kitchens.kitchenSelectedId)
        this.props.dispatch(viewKitchenTeamTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }

    actionButtonsCreator = (cell, row) => {
        let attritionEmployee =""

        let employeeMovement =""

        let moveEmployee=""


        let changeWorkStationBtn=""


        if(Helpers.checkPrivileges("/dashboard/employees/addAttrition",this.props.user) && !row.current_movements ){

            changeWorkStationBtn=<ChangeWorkStation data={row}/>
         
         }

    if(Helpers.checkPrivileges("/dashboard/employees/addAttrition",this.props.user) && !row.current_movements ){

        attritionEmployee=<button
                title="Employee Attrition"
                className="action-button btn-warning"
                style={{ marginBottom: "1px", background : "red"}}
                onClick={(e) => {
                    e.preventDefault()
                    this.addAttrition(row)
                }}>
                <i title="Employee Attrition" className="fa fa-trash" aria-hidden="true"> Attrition</i>
            </button>

        }

        if(Helpers.checkPrivileges("/dashboard/employeeMovements/add",this.props.user) && !row.current_movements){

        employeeMovement=<button
                title="Employee Movement"
                className="action-button"
                style={{ marginBottom: "1px", background : "orange"}}
                onClick={(e) => {
                    e.preventDefault()
                    this.moveEmployee(row)
                }}>
                <i title="Employee Movement" className="icon-move" aria-hidden="true"> Move Employee</i>
            </button>

        }


        if(Helpers.checkPrivileges("/dashboard/employeeMovements/edit",this.props.user)  && row.current_movements){

        moveEmployee=<button
                title="Employee Movement"
                className="action-button"
                style={{ marginBottom: "1px", background : "orange"}}
                onClick={(e) => {
                    e.preventDefault()
                    this.moveMentEmployeePage(row)
                }}>
                <i title="Employee Movement" className="icon-move" aria-hidden="true"> Respond to Movement</i>
            </button>

        }

        if(this.props.user.roles[0].includes("Kitchen Manager") && row.id===this.props.user.profile_id){
             return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{changeWorkStationBtn}</div>
        </div>)
        }else{
             return (<div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">{changeWorkStationBtn}{moveEmployee}{attritionEmployee} {employeeMovement}</div>
            </div>)
        }

       
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationViewTeamState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.kitchens && this.props.kitchens.previousViewTeamPaginationValue
            && this.props.kitchens.previousViewTeamPaginationValue !== 1) {
            this.props.dispatch(paginationViewTeamState(1))
            this.setState({
                page: 1
            })
        }
    }

     addAttrition = (row) => {
        if (row && row.id) {
            this.props.dispatch(teamEmployeeIdForAction(row.id))
            this.props.dispatch(attritionSourceAction("kitchensTeam"))
            this.props.history.push("/dashboard/employees/addAttrition")
        } else {
            this.dialog.show({
                title: "Employees Identification number not found",
                body: 'Employees id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }


     moveEmployee = (row) => {
        if (row && row.id) {
            this.props.dispatch(employeesMovementDataForAction(row))
            this.props.history.push("/dashboard/employeeMovements/add")
        } else {
            this.dialog.show({
                title: "Employees Movement data not found",
                body: 'Employees Movement data is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

     moveMentEmployeePage = (row) => {
         this.props.history.push("/dashboard/employeeMovements/list")
    }

    


    render() {
        let sizeperPage = 15

        if (this.props.kitchens && this.props.kitchens.previousRowsPerPageValue) {
            sizeperPage = this.props.kitchens.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="kitchens-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.kitchenTeamData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}>
                      {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}
                                      
                    <TableHeaderColumn
                        dataField="code"
                        dataAlign='left'
                        dataSort={true}
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Employees Id
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="name"
                        dataAlign='left'
                        dataSort={true}
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Name
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="mobile"
                        dataAlign='left'
                        dataSort={true}
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Mobile
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="designation_name"
                        dataAlign='left'
                        dataSort={true}
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Designation
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="work_station"
                        dataAlign='left'
                        dataSort={true}
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Working Station
                    </TableHeaderColumn>
                    
                    
                     <TableHeaderColumn
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        width="300"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        kitchens: state.kitchens
    }
}

export default connect(mapStateToProps)(withRouter(ViewKitchenTeamTable))


// WEBPACK FOOTER //
// ./src/modules/Kitchens/Components/ViewKitchenTeamTable.js